/* Dónde vive el token del CRM.

   Una sesión normal va a localStorage y sobrevive a cerrar el navegador.
   La que se abre desde el super admin va a sessionStorage: muere con la pestaña.
   Es lo correcto para un acceso de soporte —entrás, mirás, cerrás— y evita
   quedar logueado dentro del CRM de un cliente sin darte cuenta. */

export const TOKEN = 'crm_token';
export const COMO_ADMIN = 'crm_como_admin';

const ss = () => { try { return window.sessionStorage; } catch { return null; } };
const ls = () => { try { return window.localStorage; } catch { return null; } };

// La sesión de la pestaña gana: si entraste como superadmin, esa es la que vale
export const leerToken = () => ss()?.getItem(TOKEN) || ls()?.getItem(TOKEN) || null;
export const esVistaDeAdmin = () => ss()?.getItem(COMO_ADMIN) === '1';

export function guardarTokenDeAdmin(token) {
  ss()?.setItem(TOKEN, token);
  ss()?.setItem(COMO_ADMIN, '1');
}

export function guardarToken(token) {
  ls()?.setItem(TOKEN, token);
  ss()?.removeItem(TOKEN);
  ss()?.removeItem(COMO_ADMIN);
}

export function borrarToken() {
  ls()?.removeItem(TOKEN); ls()?.removeItem('crm_tenant');
  ss()?.removeItem(TOKEN); ss()?.removeItem(COMO_ADMIN);
}
